/**
 * Kiwi Size Chart helpers for PDP.
 * Variant updates are patched in place in product-info.js so the chart link stays put.
 */
(function () {
  const MODAL_SELECTOR = '.kiwi-sizing-modal';
  const MODAL_CONTENT_SELECTOR = '.ks-modal-content';

  function resetModalContentHeight(modal) {
    const content = modal?.querySelector(MODAL_CONTENT_SELECTOR);
    if (!content) return;

    if (!content.style.height && !content.style.maxHeight) return;

    content.style.removeProperty('height');
    content.style.removeProperty('max-height');
  }

  function initModalHeightFix() {
    if (window.matchMedia('(max-width: 767px)').matches) return;

    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (
          mutation.type === 'attributes' &&
          mutation.target instanceof HTMLElement &&
          mutation.target.matches(MODAL_CONTENT_SELECTOR)
        ) {
          resetModalContentHeight(mutation.target.closest(MODAL_SELECTOR));
          return;
        }

        mutation.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches?.(MODAL_SELECTOR)) {
            resetModalContentHeight(node);
            return;
          }

          node.querySelectorAll?.(MODAL_SELECTOR).forEach(resetModalContentHeight);
        });
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
    });
  }

  function updateKiwiProductData(product, sectionId) {
    const scope = sectionId
      ? document.querySelector(
          `product-info[data-section="${sectionId}"], product-info[data-original-section="${sectionId}"]`
        )
      : null;
    const kiwi = scope?.querySelector('[data-kiwi-sizing-chart]');
    if (!kiwi || !product?.id) return;

    kiwi.dataset.product = String(product.id);
    kiwi.dataset.productName = product.title || '';
    kiwi.dataset.type = product.type || '';
    kiwi.dataset.vendor = product.vendor || '';
    kiwi.dataset.tags = Array.isArray(product.tags)
      ? product.tags.join(',')
      : product.tags || '';

    if (product.images) {
      kiwi.dataset.productImages = JSON.stringify(product.images);
    }

    window.ks?.loadSizing?.();
  }

  document.addEventListener('color-picker:product-changed', event => {
    const { product, sectionId } = event.detail || {};
    updateKiwiProductData(product, sectionId);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalHeightFix);
  } else {
    initModalHeightFix();
  }
})();
